import React from "react"
import { NavLink } from "react-router-dom";
const Success = () => {
  return (
    <>
      <div className="scuess-page pt-5">
        <div className="sccuess-conatiner d-flex justify-content-center align-items-center">
          <img src="/img/thumb-up.png" className="img-fluid" alt="thumimg" />
        </div>

        <div className="sccuessmessage d-flex flex-column px-4 px-lg-0">
          <div className="flex-fill">
            <div className="d-flex justify-content-center pt-5 pb-2">
              <h1 className="text-white">Thank You</h1>
            </div>

            <div className="generated-message d-flex justify-content-center">
              <img className="img-fluid" src="/img/circle_check.png" alt="check" />
              <span className="text-white">The contract is sent to creators</span>
            </div>
            <NavLink style={{ textDecoration: "none" }}
              className="nav-link  "
              to={"/dashboard"}
            >
              <div className="homepage-title d-flex justify-content-center align-items-center mt-2">
                <span>Home Page</span>
              </div>
            </NavLink>
          </div>
        </div>
      </div>

    </>
  )
}
export default Success;